import { MapTo } from '@adobe/aem-react-editable-components';
import LimitedEsign, { LimitedEsignEditConfig } from './LimitedEsign';

export default MapTo('cob-corp-acquisition/components/creditonebank/limited-esign')(LimitedEsign, LimitedEsignEditConfig);